<template>
    <div
        v-if="isReached && threshold !== null"
        class="reservationRestTimeWrapper">
        <div><b-icon-clock/>&nbsp;現在選択中の日時は{{ thresholdFormat }}までに予約を完了する必要があります。急いで予約を完了するか、別の日時での予約をご検討ください。</div>
    </div>
</template>

<script>
import YokumiruHelper from '../../YokumiruHelper'
import moment from 'moment-timezone'

export default {
    props: {
        timezone: {
            type: String,
            required: true,
        },
    },

    data: function() {
        return {
            helper: YokumiruHelper,
            interval: null,
            current: null,
            isReached: false,
        }
    },

    created: function () {
        moment.locale('ja')

        this.interval = setInterval(() => {
            if (!this.threshold) {
                this.isReached = false
                return
            }
            this.current = this.helper.userTimeNow(this.timezone)
            this.isReached = this.current.diff(this.threshold, 'minutes') > -15
        }, 1000)
    },

    beforeDestroy: function () {
        if (this.interval) {
            clearInterval(this.interval)
        }
    },

    computed: {
        threshold: function () {
            const schedule = this.$store.state.reservation.schedule
            if (!schedule) return null

            if (schedule.start_time === '24:00') {
                schedule.start_time = '00:00'
            }
            return moment(`${schedule.date.format('YYYY-MM-DD')} ${schedule.start_time}:00`).subtract(schedule.doctor.reservation_allow_before_min, 'minutes')
        },

        thresholdFormat: function () {
            if (!this.threshold || !this.current) {
                return null
            }

            let format = this.threshold.format('ah:mm')
            if (format.includes('午前12')) {
                format = format.replace('午前12', '午前0')
            }
            return format
        },
    },
}
</script>

<style lang="scss" scoped>
.reservationRestTimeWrapper {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100%;
    text-align: center;
    padding: 10px;
    background: #ECC331;
}
</style>
